// Part 1
import { createSlice } from "@reduxjs/toolkit"

// Part 2
export interface ReportErrorInitialState {
  activeServiceAddressId: null | string;
  serviceDetailsList: null | any[];
  selectedTab: null | Record<string, string | null>;
  isNewServiceDetail: boolean;
  activeTab: "CURRENT_SERVICE" | "UPDATED_SERVICE";
  showUpdateService: boolean;
  selectedTabForServiceHistory: null | any;
}

const initialState: ReportErrorInitialState = {
  activeServiceAddressId: null,
  serviceDetailsList: null,
  selectedTab: null,
  isNewServiceDetail: false,
  activeTab: "CURRENT_SERVICE",
  showUpdateService: false,
  selectedTabForServiceHistory: null
}

// Part 3
export const serviceDetailSlice = createSlice({
  name: 'serviceDetailsReducer',
  initialState,
  reducers: {
    setActiveServiceAddressId: (state, action) => {
      state.activeServiceAddressId = action.payload
    },

    setServiceDetailsList: (state, action) => {
      state.serviceDetailsList = action.payload
    },

    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload
    },

    setIsNewServiceDetail: (state, action) => {
      state.isNewServiceDetail = action.payload
    },

    setCurrentActiveTab: (state, action) => {
      state.activeTab = action.payload
    },

    setShowUpdateService: (state, action) => {
      state.showUpdateService = action.payload
    },

    setSelectedTabForServiceHistory: (state, action) => {
      state.selectedTabForServiceHistory = action.payload
    }
  }
})

// Part 4
export const { setActiveServiceAddressId, setServiceDetailsList, setSelectedTab, setIsNewServiceDetail, setCurrentActiveTab, setShowUpdateService, setSelectedTabForServiceHistory } = serviceDetailSlice.actions
export default serviceDetailSlice.reducer
